import RestaurantSvg from "@assets/images/svg/restaurant.svg";
import React from "react";
import { View } from "react-native";

export interface RestaurantIconProps {
  size?: number;
  color?: string;
}

export function RestaurantIcon({
  size = 24,
  color = "#4D4D4D",
}: RestaurantIconProps) {
  return (
    <View
      style={{
        width: size,
        height: size,
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <RestaurantSvg width={size} height={size} color={color} />
    </View>
  );
}

export default RestaurantIcon;
